<template>
<OIconInner :iconString :size :height :display :title :ariaHidden/>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { getIcon } from './configs/iconConfig';
import OIconInner from './OIconInner.vue';
import { type OIconProps } from './OIconSync.vue';

const props = withDefaults(defineProps<OIconProps>(), {
	name: 'placeholder',
	set: 'base',
});

const iconString = ref('');

watch(
	() => props.name,
	async (val) => {
		iconString.value = await getIcon(props.set, val);
	},
);

iconString.value = await getIcon(props.set, props.name);
</script>
